import { mixed, number, object, ObjectSchema, string } from "yup";
import { ProductSelectFormError, RequiredDimensionError } from "./constants.ts";
import { models } from "types/api/viewModels.ts";
import { COLOR_NOT_LISTED_DESCRIPTION, VENDOR_NOT_LISTED_DESCRIPTION } from "../AddColorMatch/AddColorMatch.tsx";
import { CharacterLimitExceeded } from "constants/text.ts";

export interface SkuAndDescription {
	sku: string | null | undefined;
	description: string | null | undefined;
}

export interface FormSchema {
	productSelect?: SkuAndDescription | null;
	productSelectQuantity: number | undefined;
	editModificationSelect: string | undefined;
}

export interface AddColorMatchSchema {
	paintVendor?: models["CustomColorVendorViewModel"] | null;
	colorOption?: models["CustomColorViewModel"] | null;
	customVendor?: string | null;
	colorCode?: string | null;
}

const productViewModelSchema = object({
	sku: string().required(),
	description: string().required()
});

export const addLineItemSchemaObject = {
	productSelect: productViewModelSchema.required(ProductSelectFormError),
	productSelectQuantity: number(),
	editModificationSelect: string()
} as const;

export const schema: ObjectSchema<FormSchema> = object(addLineItemSchemaObject);

export const addColorMatchSchemaObject = {
	paintVendor: mixed<models["CustomColorVendorViewModel"]>().required(RequiredDimensionError),
	customVendor: string().when("paintVendor", {
		is: (paintVendor: models["CustomColorViewModel"]) => paintVendor?.description === VENDOR_NOT_LISTED_DESCRIPTION,
		then: (schema) =>
			schema
				.required(RequiredDimensionError)
				.max(50, CharacterLimitExceeded)
				.test("not-empty-string", RequiredDimensionError, (value) =>
					!value || value === "" ? false : value.trim() !== ""
				),
		otherwise: (schema) => schema.notRequired()
	}),
	colorOption: mixed<models["CustomColorViewModel"]>().when("paintVendor", {
		is: (paintVendor: models["CustomColorViewModel"]) => paintVendor?.description !== VENDOR_NOT_LISTED_DESCRIPTION,
		then: (schema) => schema.required(RequiredDimensionError),
		otherwise: (schema) => schema.notRequired()
	}),
	colorCode: string().when(["paintVendor", "colorOption"], {
		is: (paintVendor: models["CustomColorViewModel"], colorOption: models["CustomColorViewModel"]) =>
			paintVendor?.description === VENDOR_NOT_LISTED_DESCRIPTION ||
			colorOption?.description === COLOR_NOT_LISTED_DESCRIPTION,
		then: (schema) =>
			schema
				.required(RequiredDimensionError)
				.max(50, CharacterLimitExceeded)
				.test("not-empty-string", RequiredDimensionError, (value) =>
					!value || value === "" ? false : value.trim() !== ""
				),
		otherwise: (schema) => schema.notRequired()
	})
} as const;

export const addColorMatchSchema: ObjectSchema<AddColorMatchSchema> = object(addColorMatchSchemaObject);
